// assets
import trustpilot from './trustpilot.png'
import sitejabber from './sitejabber.png'
// types
import type { FooterReviewPlatform } from '../types/interfaces'

export interface FooterBadgeImage {
  src: string
  width: number
  height: number
}

export const REVIEW_BADGES: Record<FooterReviewPlatform, FooterBadgeImage> = {
  trustpilot: { src: trustpilot, width: 186, height: 72 },
  sitejabber: { src: sitejabber, width: 135, height: 48 },
}
